import { makeAutoObservable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { IUserConfigPackage } from '../../../API';
import DocumentViewer, { DocumentViewerState } from './DocumentViewer';
import ReusableDialog, { ReusableDialogState } from '../ReusableDialog';

export interface IDocumentViewDialogProps {
	state: DocumentViewerDialogState;
}

class DocumentViewerDialog extends React.Component<IDocumentViewDialogProps> {
	public componentDidMount(): void {}

	render() {
		return (
			<ReusableDialog state={this.props.state.reusableDialog}>
				{this.props.state.docViewer ? (
					<DocumentViewer state={this.props.state.docViewer} />
				) : (
					<></>
				)}
			</ReusableDialog>
		);
	}
}

export default observer(DocumentViewerDialog);

export class DocumentViewerDialogState {
	public docViewer?: DocumentViewerState;

	public reusableDialog: ReusableDialogState = new ReusableDialogState();
	userConfig: IUserConfigPackage;

	constructor(userConfig: IUserConfigPackage) {
		this.userConfig = userConfig;
		makeAutoObservable(this);
	}

	public async show(
		documentIdOrUrl: string,
		title: string,
	): Promise<void> {
		this.docViewer = new DocumentViewerState(this.userConfig);

		await this.docViewer.setFromAttachment(documentIdOrUrl, documentIdOrUrl, '');

		this.reusableDialog.setTitle(title);
		this.reusableDialog.setWidth(Math.min(1200, document.body.scrollWidth * 0.9));
		this.reusableDialog.setVisible(true);
	}
}
